import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export type BasicInfoState = {
  country: string
  email: string
  password: string
  confirmPassword: string
  referralCode: string
  countryCode?: string
  mobileCode?: string
  userId?: string
  mobile?: string
  loginToken?: string
  businessName?: string
}

export type RootState = {
  basicInfo: BasicInfoState
}

const initialState: BasicInfoState = {
  country: "",
  email: "",
  password: "",
  confirmPassword: "",
  referralCode: "",
  countryCode: undefined,
  mobileCode: undefined,
  userId: undefined,
  mobile: undefined,
  loginToken: undefined,
  businessName: undefined,
}

const basicInfoSlice = createSlice({
  name: "basicInfo",
  initialState,
  reducers: {
    updateBasicInfo: (state, { payload }: PayloadAction<Partial<BasicInfoState>>) => {
      Object.assign(state, payload)
    },

    setCountryDetails: (
      state,
      { payload }: PayloadAction<{ country: string; countryCode: string; mobileCode: string }>,
    ) => {
      state.country = payload.country
      state.countryCode = payload.countryCode
      state.mobileCode = payload.mobileCode
    },

    setUserId: (state, { payload }: PayloadAction<string>) => {
      state.userId = payload
    },
    setUserCountry: (state, { payload }: PayloadAction<string>) => {
      state.country = payload
    },

    setMobile: (state, { payload }: PayloadAction<string>) => {
      state.mobile = payload
    },

    setMobileCode: (state, { payload }: PayloadAction<string>) => {
      state.mobileCode = payload
    },

    setCountryCode: (state, { payload }: PayloadAction<string>) => {
      state.countryCode = payload
    },

    setLoginToken: (state, { payload }: PayloadAction<string>) => {
      state.loginToken = payload
    },

    setBusinessName: (state, { payload }: PayloadAction<string>) => {
      state.businessName = payload
    },

    setEmail: (state, { payload }: PayloadAction<string>) => {
      state.email = payload
    },

    clearBasicInfo: () => {
      return initialState
    },
  },
})

export const {
  updateBasicInfo,
  setCountryDetails,
  setUserId,
  setMobile,
  setMobileCode,
  setCountryCode,
  clearBasicInfo,
  setLoginToken,
  setBusinessName,
  setUserCountry,
  setEmail,
} = basicInfoSlice.actions

export default basicInfoSlice.reducer
